import React, { useEffect, useState } from "react";
import "./styles.scss";
import { ReactComponent as UpDownIcon } from "../../../../assets/images/up-down-icon.svg";
import { ReactComponent as UpDownIcon2 } from "../../../../assets/images/up-down-icon_v1.svg";

import { ReactComponent as CoinValue } from "../../../../assets/images/icon-coin-bet-live.svg";
import { ReactComponent as IconUp } from "../../../../assets/images/icon-up.svg";
import { ReactComponent as IconDown } from "../../../../assets/images/icon-down.svg";
import { ReactComponent as LineColumn1 } from "../../../../assets/images/line-column-1.svg";
import { ReactComponent as LineColumn2 } from "../../../../assets/images/line-column-2.svg";

import { ReactComponent as BitCoin } from "../../../../assets/images/bitcoin-icon.svg";
import { ReactComponent as Warning } from "../../../../assets/images/warning.svg";
import { formatNumber } from "../../../../services/utility/utils";
import { useSelector } from "react-redux";

import {
  formatCoin,
  formatNumberForOdds,
  getRound,
  renderPercent,
} from "../../../../utils/utils";
import { useTheme } from "../../../../hook/useThemes";
import CountDown from "../../../CountDown";
import { CircularProgress } from "@mui/material";
import CircleNumber from "../../../CircleNumber";

type CartLiveProps = {
  contest: any;
};
export default function CartLiveV1({ contest }: CartLiveProps) {
  const { operatorId, lang, fixed_odds } = useTheme();
  const [isCancelled, setIsCancelled] = useState<boolean>(false);

  const coinValue = useSelector((state: any) => state?.coinPrices?.BTC || 0);
  const lockPrice = contest?.livePrice || "";
  const priceChange = (!lockPrice ? 0 : coinValue - contest?.livePrice) * 2;
  const HEIGHT = 80;
  const translateY = !lockPrice
    ? 0
    : Math.abs(priceChange) > HEIGHT
    ? HEIGHT
    : Math.abs(priceChange);

  const position = contest?.position || "";

  useEffect(() => {
    let timeOut = null;
    if (!lockPrice) {
      timeOut = setTimeout(() => {
        setIsCancelled(true);
      }, 11000);
    }

    if (contest?.status?.toLowerCase() === "voided") {      
      setIsCancelled(true);
    }

    return () => {
      window.clearTimeout(timeOut);
    };
  }, [lockPrice, contest?.status]);

  return (
    <>
      <div className="live-card-container">
        <div className={`card-title ${operatorId === 1 && "card-title-min"}`}>
          <div className="round">
            {lang?.round || "Round"} #{getRound(contest?.contestLiveTime)}
          </div>
          <div className="name">
            <span className="title-live">
              <svg
                width="12"
                height="12"
                viewBox="0 0 12 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M9 6L4.5 8.59808L4.5 3.40192L9 6Z" fill="white" />
                <circle
                  cx="6"
                  cy="6"
                  r="5.5"
                  stroke={operatorId === 2 ? "#fff" : "#00FF00"}
                />
              </svg>

              {lang?.live || "LIVE"}
            </span>
          </div>

          <div className="amount">
            {!!contest?.prizePool &&
              !!contest?.whitelabelMoonOdds &&
              !!contest?.whitelabelRektOdds &&
              !fixed_odds && <>${formatNumber(contest?.prizePool, 2)}</>}
          </div>
        </div>
        <div className={`wrap-live-cart wrap-live-cart-${operatorId}`}>
          {lockPrice && (
            <>
              {contest?.wager && (
                <div
                  className={`wrap-value-bet
                    ${position !== "moon" && "wrap-value-bet-down"}
                    ${fixed_odds && "wrap-value-bet-fixed_odds"}
              `}
                >
                  <div
                    className={`value-bet
               animate__animated
               ${lockPrice && "animate__headShake animate-delay-05"}
              `}
                  >
                    <CoinValue />{" "}
                    <span>${formatNumberForOdds(contest?.wager, true)}</span>
                  </div>
                  <span className="label-bet">
                    {!fixed_odds && `${lang?.your_bet || "Your Bet"}`}
                    {fixed_odds &&
                      `@${formatNumberForOdds(
                        position === "moon"
                          ? contest?.whitelabelMoonOdds
                          : contest?.whitelabelRektOdds
                      )} to win`}
                  </span>
                  {fixed_odds && (
                    <div className="wrap-result-win-fixed-odds">
                      <span>$</span>
                      <p>
                        {/* {formatNumber(
                          contest.wager *
                            Number(
                              formatNumber(
                                position === "moon"
                                  ? contest?.whitelabelMoonOdds
                                  : contest?.whitelabelRektOdds,
                                2
                              )
                            ),
                          2
                        )} */}
                        {formatNumberForOdds(
                          contest.wager *
                            (position === "moon"
                              ? contest?.whitelabelMoonOdds
                              : contest?.whitelabelRektOdds)
                        )}
                      </p>
                    </div>
                  )}
                </div>
              )}

              <div
                className={`wrap-live-up ${
                  priceChange > 0 && "live-up-animation"
                }`}
              >
                {!!contest?.whitelabelMoonOdds && !fixed_odds && (
                  <div className="value-odds">
                    <span className="label">{lang?.odds || "Odds"}</span>
                    <span className="value">
                      {formatNumberForOdds(contest?.whitelabelMoonOdds)}
                    </span>
                  </div>
                )}
                <div className={`icon-up`}>
                  <IconUp />
                </div>
                {/* {operatorId === 2 ? <UpDownIcon2 /> : <UpDownIcon />} */}
                <UpDownIcon />
              </div>
              <div
                className={`wrap-live-down ${
                  priceChange < 0 && "live-down-animation"
                }`}
              >
                {!!contest?.whitelabelRektOdds && !fixed_odds && (
                  <div className="value-odds">
                    <span className="label">{lang?.odds || "Odds"}</span>
                    <span className="value">
                      {formatNumberForOdds(contest?.whitelabelRektOdds)}
                    </span>
                  </div>
                )}
                <div className={`icon-down`}>
                  <IconDown />
                </div>
                {/* {operatorId === 2 ? <UpDownIcon2 /> : <UpDownIcon />} */}
                <UpDownIcon />
              </div>

              <div className="line-locked-price">
                <div className="value-locked-price">
                  {lockPrice ? (
                    <>
                      <span className="syb-price">$</span>
                      <span className="locked-price">
                        {formatCoin(lockPrice, 0)}.
                      </span>
                      <span className="locked-percent">
                        {renderPercent(lockPrice)}
                      </span>
                    </>
                  ) : (
                    <span className="loading-locked-price">
                      {lang?.loading || "Loading"}...
                    </span>
                  )}
                </div>
                <div className="label-locked-price">
                  {lang?.locked_price || "Locked Price"}
                </div>
              </div>

              <div className="wrap-line-up-down">
                {operatorId === 2 ? <LineColumn2 /> : <LineColumn1 />}
                <div
                  className={`wrap-bit-coin ${
                    priceChange > 0 && "wrap-bit-coin-up"
                  } ${priceChange < 0 && "wrap-bit-coin-down"}
              `}
                  style={{
                    transform:
                      priceChange > 0
                        ? `translateY(-${translateY}px)`
                        : priceChange < 0
                        ? `translateY(${translateY}px)`
                        : "translateY(0px)",
                  }}
                >
                  <BitCoin />
                  <div className="line-value" />
                  <div
                    className={`wrap-live-value ${
                      translateY === HEIGHT && "wrap-live-value-shake"
                    }`}
                  >
                    <span className="syb-price">$</span>
                    <span className="locked-price">
                      {formatCoin(coinValue, 0)}.
                    </span>
                    <span className="locked-percent">
                      {renderPercent(coinValue)}
                    </span>
                  </div>
                </div>
              </div>
              <div className="wrap-line-up-down-bg" />
            </>
          )}
          {lockPrice && (
            <div className={`wrap-time-end wrap-time-end-${position}`}>
              {!fixed_odds || operatorId === 2 ? (
                <CountDown
                  expiryTime={contest?.contestCloseTime}
                  prefix={lang?.ends_in || "ends in"}
                />
              ) : (
                <div className="wrap-time-CircleNumber">
                  <CircleNumber contestLiveTime={contest?.contestCloseTime} />
                </div>
              )}
            </div>
          )}
        </div>

        <div
          className={`wrap-start-new-round animate__animated
          wrap-start-new-round-${
            contest?.position === "moon"
              ? "above"
              : contest?.position === "rekt"
              ? "below"
              : ""
          }
          ${lockPrice && `puff-out-center`}
          `}
        >
          <p>
            {lang?.loading_round || "Loading Round"} #
            {getRound(contest?.contestLiveTime)}
          </p>
          <CircularProgress
            size={40}
            className="circular-progress"
            style={{
              color: !position
                ? "#B3BECE"
                : contest?.position === "moon"
                ? "#000"
                : "#fff",
            }}
          />
        </div>

        {isCancelled && (
          <div className="wrap-content-canceled">
            <div className="wrap-title">
              <Warning />
              <p>{lang?.round_cancelled || "Round Cancelled"}</p>
            </div>
            <div className="wrap-content">
              <p
                dangerouslySetInnerHTML={{
                  __html:
                    lang?.round_cancelled_content ||
                    "Due to technical issues loading the locked price, this round is canceled.<br /><br />All bets will be refunded.",
                }}
              />
            </div>
          </div>
        )}
      </div>
    </>
  );
}
